import React, { Component } from 'react';
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {getCustomers} from "../../redux/actions";
import {Button, Grid, Row, Table} from "react-bootstrap";

import CustomerTableRow from "./CustomerTableRow";
import {authorised} from '../layout/authorised';

class CustomerOverview extends Component {
    constructor(props) {
        super(props);
        props.dispatch(getCustomers());
    }

    newCustomer(e) {
        this.props.history.push('/customers/create')
    }

    render() {
        return (
            <Grid>
                <Row>
                    <h2>Customers</h2>
                    <Table striped bordered condensed hover>
                        <thead>
                            <tr>
                                <th>Number</th>
                                <th>Customer</th>
                                <th>Address</th>
                                <th>
                                    Private url
                                    <Button onClick={e => this.newCustomer(e)} id="add-customer">
                                        <i className="fas fa-plus"/>
                                    </Button>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.props.customers ? this.props.customers.map(c => <CustomerTableRow key={c.id} customer={c}/>) : null}
                        </tbody>
                    </Table>
                </Row>
            </Grid>
        );
    }
}

const mapStateToProps = state => {
    return { customers: state.customers };
};

const mapDispatchToProps = (dispatch) => ({dispatch});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(authorised(CustomerOverview)));



// WEBPACK FOOTER //
// ./src/components/customer/CustomerOverview.js